import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}

import { computed, watch, nextTick, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriterionSelectorDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionSelectorDialog"

    type CriterionNode = {
        Id: number
        ParentId: number | null
        Name: string
        Subcriteria: CriterionNode[]
    }

    // ---------------- helpers ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriterionSelectorDialog',
  props: {
        viewModel: {
            type: Object as PropType<CriterionSelectorDialogViewModel>,
            required: true
        }
    },
  emits: ["confirm-selection"],
  setup(__props, { emit: __emit }) {

    const $ = ((window as any).kendo?.jQuery ?? (window as any).$) as JQueryStatic

    // ---------------- props / emits ----------------

    const props = __props

    const emit = __emit

    // ---------------- computed ----------------

    const vm = toRef(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    // ---------------- types ----------------

    function buildTree(criteria: any[]): CriterionNode | undefined
    {
        const map = new Map<number, CriterionNode>()
        let root: CriterionNode | undefined

        // create nodes
        for (const c of criteria)
        {
            map.set(c.Id, {
                Id: c.Id,
                ParentId: c.ParentId,
                Name: c.Name,
                Subcriteria: []
            })
        }

        // wire hierarchy
        for (const node of map.values())
        {
            if (node.ParentId == null)
            {
                root = node
            } else
            {
                map.get(node.ParentId)?.Subcriteria.push(node)
            }
        }

        return root
    }

    // ---------------- watcher ----------------

    watch(opened, async (val) =>
    {
        if (!val) return

        const goal = buildTree(vm.value.criteria)
        if (!goal) return

        await nextTick()

        $("#treeview").kendoTreeView({
            dataSource: new kendo.data.HierarchicalDataSource({
                data: [goal],
                schema: {
                    model: {
                        id: "Id",
                        children: "Subcriteria"
                    }
                }
            }),
            dataTextField: "Name",
            loadOnDemand: false
        })

        const treeview = $("#treeview").data("kendoTreeView")

        const selected = treeview.dataSource.get(vm.value.selectedCriterionId)

        // expand path to selected first (important)
        if (selected) {
            treeview.expandTo(selected)
        }

        // expand first visible level
        treeview.dataSource.view().forEach((node: any) =>
        {
            treeview.expand(treeview.findByUid(node.uid))
        })

        // finally select
        if (selected) {
            treeview.select(treeview.findByUid(selected.uid))
        }

    })

    // ---------------- actions ----------------

    function confirm()
    {
        const tv = $("#treeview").data("kendoTreeView")
        const selectedNode = tv.select()
        const item = tv.dataItem(selectedNode)

        emit('confirm-selection', item.id)
        close()
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "modal-wrapper" }, [
          _createElementVNode("div", { class: "modal-dialog modal-dialog-scrollable" }, [
            _createElementVNode("div", { class: "modal-content" }, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Select a criterion", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
                _createElementVNode("div", { id: "treeview" })
              ], -1 /* CACHED */)),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, " Close "),
                _createElementVNode("button", {
                  type: "button",
                  onClick: confirm,
                  class: "btn btn-success"
                }, " Confirm ")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})